import React from "react";

import "./global.scss";
import { Main } from "./pages/main/main";
import { PlayCanvasPlayer } from "./components/PlayCanvasPlayer/PlayCanvasPlayer";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { ListBoat } from "./pages/ListBoat/ListBoat";

function App() {
  return (
    <Router>
      <Switch>
        <Route path="/:id">
          <div className="constructor">
            <PlayCanvasPlayer />
            <Main />
          </div>
        </Route>
        <Route path="/">
          <ListBoat></ListBoat>
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
